import { createFileRoute, redirect } from '@tanstack/react-router';

/** Pure redirect (Stuart ruling 2026-08-25, BUILD_SPEC.md §8.1's dated
 * amendment note): "Receive without weighbridge" is no longer a separate
 * screen — it's the optional no-ticket branch of the "Receive a load" step 2
 * (`/purchasing-intake`, ReceiveLoadWizard.tsx). This route file stays only so
 * old links/bookmarks still land somewhere useful instead of 404ing. */
export const Route = createFileRoute('/_authenticated/purchasing-intake/receive-manual')({
  beforeLoad: () => {
    throw redirect({ to: '/purchasing-intake' });
  },
});
